<div class="lottery-popup-wrapper">
  <img alt="Maintenance Alert" lib-amdocs-image-version class="lottery-popup-img" src="assets\icons\recovery\alert.svg">
  
  <div class="text-small-normal lottery-popup-description">
    
  </div>
  <div class="label-h4 lottery-popup-title">
      {{amdocsContentConstant?.dbupgrade.title}}
  </div>
  <div class="text-small-normal lottery-popup-description">
    {{amdocsContentConstant?.dbupgrade.msg}}
  </div>
  <div class="lottery-popup-btn-wrapper">
    <button class="btn btn-medium primary send-notifications-btn"
            (click)="close()">
      {{amdocsContentConstant?.dbupgrade.button}}
    </button>
  </div>
</div>
